import { apiPostJSON } from "../client.js";
import { requestsCurrent } from "../core/request-coordinator.js";
import { loadThreadComponent } from "./snapshot.js";
import { activeThreadTurnFromState, threadSendBlockReason } from "./state.js";

export function requireAPIKey(apiKey) {
  if (!String(apiKey || "").trim()) {
    throw new Error("Enter an API key first.");
  }
}

export async function submitThreadPrompt(state, apiKey, form, options = {}, behavior = {}) {
  requireAPIKey(apiKey);
  const threadItem = state.thread;
  if (!threadItem) {
    throw new Error("Select a thread first.");
  }
  const prompt = String(state.composerDraft || "").trim();
  if (!prompt) {
    throw new Error("prompt is required");
  }
  const activeTurn = activeThreadTurnFromState(state);
  const sendBlockReason = threadSendBlockReason(state, threadItem, activeTurn);
  if (sendBlockReason) {
    throw new Error(sendBlockReason);
  }

  const promptField = form.elements.namedItem("prompt");
  const sendButton = form.querySelector(".composer-v2__send");
  state.submitting = true;
  state.composerDraft = "";
  if (promptField instanceof HTMLTextAreaElement) {
    promptField.value = "";
  }
  if (sendButton instanceof HTMLButtonElement) {
    sendButton.disabled = true;
  }
  options.render?.();

  try {
    const sendingStatus = String(behavior.sendingStatus || "").trim();
    if (sendingStatus) {
      options.setStatus?.(sendingStatus, "busy");
    }
    const created = await apiPostJSON(apiKey, `/v1/threads/${encodeURIComponent(threadItem.id)}/messages`, { prompt });
    await options.refreshCollections?.();
    if (!requestsCurrent(options.request)) {
      return false;
    }
    const loaded = await loadThreadComponent(state, apiKey, threadItem.id, {
      request: options.request,
      includeDiagnostics: options.includeDiagnostics
    });
    if (!requestsCurrent(options.request) || !loaded) {
      return false;
    }
    await behavior.afterLoad?.({
      created,
      threadItem,
      state,
      apiKey,
      options
    });
    const successMessage = typeof behavior.successMessage === "function"
      ? behavior.successMessage({ created, threadItem, state })
      : String(behavior.successMessage || "").trim();
    if (successMessage) {
      options.setStatus?.(successMessage, "ok");
    }
    return true;
  } catch (error) {
    state.composerDraft = prompt;
    if (promptField instanceof HTMLTextAreaElement) {
      promptField.value = prompt;
    }
    throw error;
  } finally {
    state.submitting = false;
    options.render?.();
  }
}
